import { retrieveMatterTeammatesQueryOptions } from "@/lib/data/react-query/matters/matter-teammate";
import { useQueries, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

export function useMatterPersonnelRoster(
  initialTeamIds: string[],
  teamIds: string[],
) {
  const [seenTeamIds, setSeenTeamIds] = useState<string[]>([]);
  const queryClient = useQueryClient();
  const newTeamIds = teamIds.filter((id) => !initialTeamIds.includes(id));
  const queryTeamIds = [...new Set([...newTeamIds, ...seenTeamIds])];
  const queries = useQueries({
    queries: queryTeamIds.map((id) =>
      retrieveMatterTeammatesQueryOptions({ id }),
    ),
  });
  const roster = queries.flatMap((query) => query.data?.data ?? []);
  const activeRoster = roster.filter((member) =>
    newTeamIds.includes(member.teamId),
  );

  return {
    newTeamIds,
    roster,
    activeRoster,
    rostersLoading: queries.some(
      (query, index) =>
        newTeamIds.includes(queryTeamIds[index]) && query.isPending,
    ),
    rostersErrored: queries.some(
      (query, index) =>
        newTeamIds.includes(queryTeamIds[index]) && query.isError,
    ),
    retryRosters: async () => {
      await Promise.all(
        queries
          .filter((query) => query.isError)
          .map((query) => query.refetch()),
      );
    },
    rememberTeam: async (teamId: string) => {
      setSeenTeamIds((current) => [...new Set([...current, teamId])]);
      const response = await queryClient.ensureQueryData(
        retrieveMatterTeammatesQueryOptions({ id: teamId }),
      );
      return response.data;
    },
  };
}
